export enum UserRole {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',
  COMPANY_DIRECTOR = 'COMPANY_DIRECTOR',
  EXECUTIVE = 'EXECUTIVE',
  HR = 'HR',
  HR_MANAGER = 'HR_MANAGER',
  FINANCE = 'FINANCE',
  OPERATIONS = 'OPERATIONS',
  MANAGER = 'MANAGER',
  PROCUREMENT_ADMIN_AFFAIRS = 'PROCUREMENT_ADMIN_AFFAIRS',
  EMPLOYEE = 'EMPLOYEE'
}

export enum EmployeeStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  ON_LEAVE = 'ON_LEAVE',
  TERMINATED = 'TERMINATED'
}

export enum RequestType {
  ADVANCE = 'ADVANCE',
  LEAVE_PAID = 'LEAVE_PAID',
  LEAVE_UNPAID = 'LEAVE_UNPAID',
  LEAVE_REPORT = 'LEAVE_REPORT'
}

export enum RequestStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  CANCELLED = 'CANCELLED'
}

export enum PayrollStatus {
  DRAFT = 'DRAFT',
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  ACKNOWLEDGED = 'ACKNOWLEDGED'
}

export enum DocumentType {
  POLICY = 'POLICY',
  TRAINING = 'TRAINING',
  CONTRACT = 'CONTRACT',
  OTHER = 'OTHER'
}

export enum WorkflowStatus {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export enum InventoryCategory {
  PROJECT_STOCK = 'PROJECT_STOCK',
  PROMOTIONAL = 'PROMOTIONAL',
  PPE = 'PPE'
}

export enum PpeAssignmentStatus {
  ASSIGNED = 'ASSIGNED',
  RETURN_REQUESTED = 'RETURN_REQUESTED',
  RETURNED = 'RETURNED'
}

export enum ProcurementRequestType {
  PPE = 'PPE',
  GENERAL = 'GENERAL'
}

export enum ProcurementRequestStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  CANCELLED = 'CANCELLED'
}

export enum DisciplineDefenseStatus {
  PENDING = 'PENDING',
  RECEIVED = 'RECEIVED',
  NOT_RECEIVED = 'NOT_RECEIVED'
}

export enum DisciplineOutcome {
  NO_ACTION = 'NO_ACTION',
  WARNING = 'WARNING',
  TERMINATION = 'TERMINATION'
}
